import React, { useEffect, useRef, useState } from 'react'
import axios from 'axios'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import { getApiHeader } from 'utlis/commonfunctions';
import DropIn from 'braintree-web-drop-in-react';
import Modal from 'react-bootstrap/Modal';
import { Button } from 'react-bootstrap';
import ActivationHead from './ActivationHead';
import Loader from "./loader";







function CreateAccount({ nextStep, prevStep , commonSession, retailerDetails }) {
    const sessionId = commonSession;
    const SERVER_URL = process.env.REACT_APP_API_URL
    const [checkBoxStatus, setCheckBoxStatus] = useState("")
    const [email, setEmail] = useState("")
    const [cemail, setcemail] = useState("")
    const [otp, setOtp] = useState("")
    const [otpSessionId, setOtpSessionId] = useState()
    const [modelVisibility, setModelVisibility] = useState(false)
    const [clientToken, setClientToken] = useState('');
    const instanceRef = useRef(null);
    const [loading, setLoading] = useState(false);

    const[selected,setSelected]=useState(true)
    const[formData,setFormData]=useState({
        email:"",
        password:"",
        password_confirm:"",
        cemail:""
    });
     

    const[passWordError,setPassWordError]=useState(null);
    const [showPaymentGateway,setshowPaymentGateway]=useState(false);
    const [email_verification_send,setEmailVerificationSend]=useState(false);
    const [verified_email,setVerified_email]=useState(false);
    const [addCard,setAddcard]=useState(false);

    const retailer_type = retailerDetails?.retailerType;
    const myaccount_display = retailerDetails?.myaccount_display;;
    const otp_verification_status = retailerDetails?.otp_verification_email;



    


    console.log(retailerDetails);





      const handleCheckBoxChange=()=>{

        if(selected){
            setSelected(false)
            setEmailVerificationSend(false);
            if(otp_verification_status===false && myaccount_display === true){ setVerified_email(true); }else{ setVerified_email(false); }
            setAddcard(false);
        }else{
            setSelected(true);
            setOtp("");
            setAddcard(true);

        }

      }




        const handleChange=(event)=>{
               const{name,value}=event.target
              if(name==="email"){
                setFormData((prevData)=>({
                    ...prevData,
                    email:value,
                    
                }))}

            else if(name==="cemail"){
                setFormData((prevData)=>({
                    ...prevData,
                    cemail:value,
                    
                }))}

              else  if(name==="password"){
                    setFormData((prevData)=>({
                        ...prevData,
                        password:value,
                    }))
                }else if( name==="confirm-password"){
                    if(password!=value){
                        setPassWordError(true)
                     }else{
                        setPassWordError(false)
                     }
                       setFormData((prevData)=>({
                        ...prevData,
                        password_confirm:value,
                       }))
                      
                }
        }




    useEffect(() => {
        if(otp_verification_status===false && myaccount_display === true){ setVerified_email(true)}
        handleGetNumber();
        if(myaccount_display === true){
            handleClientToken();
        }
        
    }, [])




    const handleGetNumber = async () => {

        if(myaccount_display === false){
            setSelected(false);
        }
        

        try {
            const header = await getApiHeader()
            const params = new URLSearchParams();
            params.append(sessionId);
            const response = await axios.get(`${SERVER_URL}wme-prepaid-activation/create/account?${params.toString()}`, { headers: header });

            if (response.status === 200) {
                setCheckBoxStatus(response?.data?.data.register_my_account_check_box_status)
            }

        } catch (error) {

        }

    }



    const handleSendOtp = async () => {
        try {

            if(formData.email ===null || formData.email ===''){
                 swal("", "Please enter valid email.", 'warning');
                 return;
            }


            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(formData.email)){
                swal("", "Please enter valid email", 'warning');
                return ;
            }


            setLoading(true);
            const otpFormData = {
                session_id: commonSession,
                email: formData.email,
            }
            const headers = await getApiHeader()
            const response = await axios.post(`${SERVER_URL}wme-prepaid-activation/send/otp/register`, otpFormData, {
                headers: headers
            })

            if (response.status === 200) {
                setOtpSessionId(response.data.data.otp_session_id);
                setEmailVerificationSend(true);
                setLoading(false);
            } else {
                 swal("", "Unexpected error please try again.", 'error');
            }

            setLoading(false);

        } catch (error) {

             setLoading(true);
             if (error.response) {
                const apiErrors = error.response.data.message;


                if (typeof(apiErrors) === 'string') {
                   swal("", apiErrors, 'warning');
                   setLoading(false);
                   return;
                }else{
                    swal("", "Unexpected error please try again.", 'error');
                }
            }else{
                swal("", "Unexpected error please try again.", 'error');
            }

        }

    }


    const handleVerifyOtp = async () => {
        try {

            if(otp ===null || otp ===''){
                swal("", "Please enter valid otp", 'warning');
                return;
            }


            setLoading(true);
            const VerifyOtpFormData = {
                session_id: commonSession,
                email: formData.email,
                otp_session_id: otpSessionId,
                otp: otp
            }
            const headers = await getApiHeader()
            const response = await axios.post(`${SERVER_URL}wme-prepaid-activation/verify/otp/register`, VerifyOtpFormData, {
                headers: headers
            })

            if (response.status === 200) {
                swal("", "Email Verification Completed", 'success');
                setVerified_email(true);
                setLoading(false);
            } else {
                 swal("", "Unexpected error please try again.", 'error');
            }

        } catch (error) {
            if (error.response) {
                const apiErrors = error.response.data.message;

                setLoading(false);
                if (typeof(apiErrors) === 'string') {
                   swal("", apiErrors, 'warning');
                   return;
                }else{
                    swal("", "Unexpected error please try again.", 'error');
                }
            }else{
                    swal("", "Unexpected error please try again.", 'error');
            }
        }

    }


    const handleClose = () => {
        setModelVisibility(false)
    }





    const handleClientToken= async(e)=>{
           try {


           if(addCard){
                setAddcard(false);
                setshowPaymentGateway(false);
                return;
           }else{
                setAddcard(true);
               
           }

           setLoading(true);
           const headers= await getApiHeader()
         
           const response= await axios.get(`${SERVER_URL}wme-prepaid-activation/client_token`,{headers:headers})
           console.log("response,client token",response.data.data.clientToken)
            
            if(response.status===200){
                setClientToken();
                setClientToken(response.data.data.clientToken)
                setshowPaymentGateway(true)
                setLoading(false);
                  
            }

           } catch (error) {
                if (error.response) {
                    const apiErrors = error.response.data.message;


                        if (typeof(apiErrors) === 'string') {
                           swal("", apiErrors, 'warning');
                           setLoading(false);
                           return;
                        }else{
                            swal("", "Unexpected error please try again.", 'error');
                        }
                }else{
                    swal("", "Unexpected error please try again.", 'error');
                }
                setLoading(false);
           }
    }





    const mySubmitHandler = async (e) => {
        e.preventDefault();


         if(formData.email ===null || formData.email ===''){
                 swal("", "Please enter valid email address.", 'warning');
                 return;
        }


        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)){
            swal("", "Please enter valid email address", 'warning');
            return ;
        }


        if((myaccount_display ===false || selected === false) && (formData.cemail ==='' || formData.cemail === null)){

            swal("", "Please confirm your email address.", 'warning');
            return;
        }


        if((myaccount_display === false || selected === false) && (formData.cemail.toLowerCase() !== formData.email.toLowerCase())){

            swal("", "Email and confirmation email must be the same.", 'warning');
            return;
        }



        if(selected){
            

            if(formData.password ===null || formData.password ===''){
                 swal("", "Please enter valid password.", 'warning');
                  return;
            }


            if(formData.password.length < 8){
                 swal("", "The password must be at least 8 characters.", 'warning');
                  return;
            }


            if(formData.password_confirm ===null || formData.password_confirm ===''){
                 swal("", "Please confirm password.", 'warning');
                  return;
            }



            if(formData.password  != formData.password_confirm){
                 swal("", "Password not matched, please check.", 'warning');
                  return;
            }

        }


        setLoading(true);

        try {
            console.log(addCard);

            let nonce = null;
            if (addCard) {
                const paymentMethod = await instanceRef.current.requestPaymentMethod();
                nonce = paymentMethod.nonce;
            }

            console.log(nonce);

            console.log(addCard);


            const headers = await getApiHeader();
            const formDataWithSession = { ...formData, session_id:commonSession, register_my_account:selected, email_address_confirm:formData.email, add_card:addCard, payment_method_nonce: nonce };

            const response = await axios.post(
                `${SERVER_URL}wme-prepaid-activation/update/account`,
                formDataWithSession,
                { headers }
            );


             var response_error = true;
            if(response.status===200){
                if(response.data.message !== 'undefined'){

                    var response_error = false;
                    console.log('API Response:', response);
                    setLoading(false);
                    nextStep();
                }
            }

            if(response_error===true){ swal("Unexpected error", "Please try again.", 'error'); }
            setLoading(false);

        } catch (error) {

            if (error.response) {
                const apiErrors = error.response.data.message;

                if (typeof(apiErrors) === 'string') {
                   swal("", apiErrors, 'warning');
                   setLoading(false);
                   return;
                } else if (typeof apiErrors === 'object') {
                    const formattedErrors = {};
                    for (const field in apiErrors) {
                        formattedErrors[field] = apiErrors[field][0]; 
                        swal("", formattedErrors[field], 'warning');
                        setLoading(false);
                        return;
                    }

                }
            }            
           
        } finally {
            setLoading(false); 
        }
    };



    const handleSetOtp = (value) => {
        const numericValue = value.replace(/[^0-9]/g, "");
        setOtp(numericValue);
    };







    return (
        <div>
            <DashboardLayout>
                <DashboardNavbar />
                <ActivationHead />
                <div className="formbold-main-wrapper add-plan-wrapper">
                    <div className="formbold-form-wrapper add-plan-form pos-rel">

                         {loading === true && (
                            <Loader />
                        )}

                        {myaccount_display ===true ?
                            <h6> Create  Account</h6>
                        :
                            <h6> Customer Email Address</h6>
                        }
                        <hr/>
                        <br/>
                        <form onSubmit={mySubmitHandler} className="add-plan-form create-account">

                            {myaccount_display === true && (
                                <div className="formbold-mb-5 formbold-pt-3 col-lg-12">
                                    <div className="formbold-mb-5 formbold-pt-3">
                                        <div className='business-customer checkpik'>
                                            <label className="check-box">
                                                <input
                                                    type="checkbox"
                                                    name="bussiness-checkbox"
                                                    id="bussiness-checkbox"
                                                    checked={selected}
                                                    onChange={handleCheckBoxChange}
                                                />
                                                Register My Account

                                                <span className="tick"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="makeflex mob-dis-blok">

                                <div className="formbold-mb-5 formbold-pt-3 col-lg-6 fullwidth-nopad">
                                    <label className="formbold-form-label formbold-form-label-2">Email Address <span className="madate_mark">*</span></label>

                                    {email_verification_send === false ?
                                   
                                    <input
                                    autoComplete="new-password"
                                        type="email"
                                        name="email"
                                        id="email"
                                        placeholder="Enter email"
                                        maxLength="60"
                                        className="formbold-form-input"
                                        value={formData.email }
                                        onChange={handleChange}
                                    />
                                    :

                                    <input
                                    autoComplete="new-password"
                                        type="email"
                                        name="email"
                                        id="email"
                                        placeholder="Enter email"
                                        className="formbold-form-input"
                                        value={formData.email }
                                        readOnly
                                        style={{width:'90%'}}
                                    />

                                    }

                                    
                                </div>


                                {(myaccount_display ===false || selected === false) &&(
                                    <>
                                        <div className="formbold-mb-5 formbold-pt-3 col-lg-6 padl-space fullwidth-nopad">
                                            <label className="formbold-form-label formbold-form-label-2">Confirm Email Address <span className="madate_mark">*</span></label>


                                            <input
                                                type="email"
                                                name="cemail"
                                                id="cemail"
                                                placeholder="Confirm email address"
                                                className="formbold-form-input"
                                                value={formData.cemail }
                                                maxLength="60"
                                                onChange={handleChange}
                                                autoComplete="new-password"

                                            />

                                        </div>
                                    </>
                                )}





                                { selected&& (
                                    <>  

                                        {(email_verification_send === false && otp_verification_status ===true) &&(

                                            <div className="formbold-mb-5 formbold-pt-3 col-lg-6 col-md-4">
                                            <label className="formbold-form-label formbold-form-label-2" style={{visibility:'hidden'}}>verify email address</label>
                                                <button className="btn  add-mb-otp-btn  " type="button" onClick={() => handleSendOtp()} > Verify Email </button>
                                            </div>

                                        )}



                                        {email_verification_send === true && (
                                            <>
                                            {verified_email === false &&(
                                            <div className="formbold-mb-5 formbold-pt-3  col-lg-6">
                                                <label className="formbold-form-label formbold-form-label-2">Enter OTP <span className="madate_mark">*</span></label>
                                                <div className="input-group">
                                                    <input type="text" className="formbold-form-input addInput" maxLength="6" placeholder="Enter OTP Number" name="otp" keyboardType="numeric"  autoComplete="new-password" value={otp} onChange={(e) => handleSetOtp(e.target.value)}
                                                        style={{ width: '70%' }} aria-describedby="request_port_otp" />
                                                    <div className="input-group-append spc-exitotp-width">
                                                        <button className="btn btn-send-otp add-mb-otp-btn" type="button" onClick={() => handleVerifyOtp()} > Verify OTP </button>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                            )}
                                            </>
                                        )}
                                    </>
                                        
                                )}


                            </div>


                            {(selected ===true && verified_email ===true) &&(
                            <>
                                <div className="registerBlock">

                                        { selected&&
                                        <div className="formbold-mb-5 formbold-pt-3 col-lg-6">
                                            <label className="formbold-form-label formbold-form-label-2">Password <span className="madate_mark">*</span></label>
                                            <input
                                                type="password"
                                                name="password"
                                                id="password"
                                                placeholder="Enter password"
                                                className="formbold-form-input"
                                                autoComplete="off"
                                            value={formData.password}
                                            maxLength={20}
                                            onChange={handleChange}
                                            />
                                        </div>}


                                          {selected&&  
                                        <div className="formbold-mb-5 formbold-pt-3 col-lg-6">
                                            <label className="formbold-form-label formbold-form-label-2">Password Confirmation <span className="madate_mark">*</span></label>
                                            <input
                                                type="password"
                                                name="confirm-password"
                                                id="confirm-password"
                                                placeholder="Password Confirmation"
                                                className="formbold-form-input"
                                                autocomplete="off"
                                                maxLength={20}
                                            value={formData.password_confirm}
                                            onChange={handleChange}
                                            />
                                            
                                        </div>}
                                         

                                </div>


                                <h6>
                                    Do you want to save payment card details of customer to Telsim My Account for future renewals ?
                                </h6>

                                <div className="formbold-mb-5 col-lg-12">
                                    <div className="formbold-mb-5 formbold-pt-3">
                                        <label className='business-customer check-box'>
                                                <input
                                                    type="checkbox"
                                                    name="bussiness-checkbox"
                                                    id="bussiness-checkbox"
                                                    checked={showPaymentGateway}
                                                    onChange={handleClientToken}
                                                />

                                                Save payment card details of customer to Telsim My Account for future renewals
                                                <span className="tick"></span>
                                            
                                        </label>
                                    </div>
                                </div>
                                
                                    <div className='col-lg-6'>
                                        {showPaymentGateway && (
                               <label className='dealer-responsive-label'> Please use payment card details of customer. Do not use dealer payment card details here. </label>

                                        )
                                        }

                                        {showPaymentGateway === true && (
                                            <DropIn
                                                options={{ authorization: clientToken }}
                                                onInstance={(instance) => (instanceRef.current = instance)}
                                            />
                                        )}

                                    </div>

                            </>
                            )}



                            <br/>
                            <br/>
                            <br/>
                            <br/>

                            <div className="button-container activationBlock-button-container">
                                <button type="button" onClick={prevStep} className="button btn btn-danger">
                                    Back
                                </button>

                                
                                {( (selected === false) || (selected === true && verified_email === true) ) && (
                                <>
                                    
                                        <button className="button btn btn-danger ad-mb-button-next">
                                            Next
                                        </button>
                                
                                </>
                                )}
                            </div>
                               
                        </form>

                        

                       

                    </div>
                </div>
            </DashboardLayout>
        </div>
    )
}

export default CreateAccount